import React, { FC, Fragment } from 'react'
import { NavLink } from 'react-router-dom'
import withAccountAndBranch from '../withAccountAndBranch'
import { IBranch, IUser } from '../../types/user'
import { withRouter } from 'react-router'
import { cartItemsAmount, cartTotal, plannedCartTotal } from '../orders'
import { getShouldRenderTruckInventoryFeature } from '../getShouldRenderTruckInventoryFeature'
import { getShouldRenderBinInventoryFeature } from '../getShouldRenderBinInventoryFeature'

interface IOwnProps {
  user: IUser
  branch?: IBranch
}

const SubHeaderManager: FC<IOwnProps> = ({ user, branch }) => {
  const ordersEnabled = user.account?.ordersEnabled ?? true
  const shouldRenderTruckInventoryFeature =
    getShouldRenderTruckInventoryFeature(
      user.account?.truckInventoryFeature,
      branch?.truckInventoryFeature,
    )
  const shouldRenderBinInventoryFeature = getShouldRenderBinInventoryFeature(
    user.account?.binInventoryFeature,
    branch?.binInventoryFeature,
  )

  return (
    <div className="subheader_menu">
      <NavLink
        activeClassName="-active"
        className="menu_root-link link"
        to="/plan"
      >
        Replenishment Plan
      </NavLink>
      <NavLink
        activeClassName="-active"
        className="menu_root-link link"
        to="/inventory"
      >
        Inventory
      </NavLink>
      <NavLink
        activeClassName="-active"
        className="menu_root-link link"
        to="/users"
      >
        Users
      </NavLink>
      <NavLink
        activeClassName="-active"
        className="menu_root-link link"
        to="/groups"
      >
        Divisions & Teams
      </NavLink>
      {ordersEnabled && (
        <NavLink
          activeClassName="-active"
          className="menu_root-link link"
          to="/orders"
        >
          Orders
        </NavLink>
      )}

      <NavLink
        activeClassName="-active"
        className="menu_root-link link"
        to="/inbound_inventories"
      >
        Inbound Inventory
      </NavLink>

      {(shouldRenderTruckInventoryFeature ||
        shouldRenderBinInventoryFeature) && (
        <NavLink
          activeClassName="-active"
          className="menu_root-link link"
          to="/locations"
        >
          Locations
        </NavLink>
      )}

      {(shouldRenderTruckInventoryFeature ||
        shouldRenderBinInventoryFeature) && (
        <NavLink
          activeClassName="-active"
          className="menu_root-link link"
          to="/cycle_counts"
        >
          Cycle Counts
        </NavLink>
      )}
      {user.account?.ordersEnabled && (
        <div className="subheader_menu-right">
          {branch && branch.cartItems && branch.suggestedCartItems && (
            <div className="menu_root-cart-info">
              {branch.cartItems.length > 0 ||
              branch.suggestedCartItems.length > 0 ? (
                branch.cartItems.length > 0 ? (
                  <>
                    {cartItemsAmount(branch)} products | {cartTotal(branch)}
                  </>
                ) : (
                  <>
                    Planned for order{' '}
                    <span className="highlight">
                      {cartItemsAmount(branch)} products |{' '}
                      {plannedCartTotal(branch)}
                    </span>
                  </>
                )
              ) : (
                'Nothing planned'
              )}
            </div>
          )}
          <NavLink
            className="menu_root-place-order-button"
            to={{ pathname: '/place_order' }}
          >
            Go to order
          </NavLink>
        </div>
      )}
    </div>
  )
}

export default withRouter(withAccountAndBranch(SubHeaderManager))
